import { createFileRoute } from '@tanstack/react-router';

import {
  bankAccountMedConsultScreen,
  accountMedSearch,
  loadBankAccountMessages,
  loadBankAccountScreens,
} from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute(
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar',
)({
  validateSearch: accountMedSearch,
  staticData: { screen: bankAccountMedConsultScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountMedConsultScreen'),
});
